import Chart from 'chart.js/auto'

document.addEventListener('turbolinks:load', () => {
  if (document.getElementById('payments-ratio') != null) {
    const context = document.getElementById('payments-ratio').getContext('2d');
    console.log(context.canvas.dataset);
    const graph_data = JSON.parse(context.canvas.dataset.paymentsData);
    const color_list = [];
    for (let i in graph_data) {
      if (i == 0) {
        color_list.push("#0CC9A7")
      } else if (i == 1) {
        color_list.push("#0AA995")
      } else if (i == 2) {
        color_list.push("#088A7A")
      } else if (i == 3) {
        color_list.push("#066B5C")
      } else {
        color_list.push("#4DD4C1")
      }
    }
    const countPlaceGraph = new Chart(context, {
      type: 'doughnut',
      data: {
        labels: JSON.parse(context.canvas.dataset.labels),
        datasets: [
          {
            label: "",
            backgroundColor: color_list,
            hoverBackgroundColor: "#0AA995",
            data: JSON.parse(context.canvas.dataset.paymentsData),
          },
        ]
      },
    });
  }
})
